// /src/store/modules/authStore.js
import db from '../../firebaseConfig'
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc, getDoc, query, where, setDoc } from "firebase/firestore";
import moment from 'moment';

const state = {
   // test: 'My first state!',
   user:{},
   signedin: false,
   fighters:[],
   fights:[],
   loaded_fights:[],
   verifiyemailaddress:false,
   fightersNames:[],
   fightsdata:[],
   todayfights: [],
    upcomingfights: [],
    pastfightsfights: [],
    usersvotes:[],
    selectorNames:[],
    updatedata: false

};
const getters = {
   user: state => {
      return state.user
   },
   role: state => {
      return state.role
   },
   fighters: state => {
      return state.fighters
   },
   loaded_fights: state => {
      return state.loaded_fights
   },
   verifiyemailaddress: state => {
      return state.verifiyemailaddress
   },
   fights: state => {
      return state.fights
   }, 
   fightersNames: state => {
      return state.fightersNames
   } ,
   fightsdata: state => {
      return state.fightsdata
   },
   signedin: state => {
     return state.signedin
   },
   todayfights: state => {
      return state.todayfights
   } ,
   upcomingfights: state => {
      return state.upcomingfights
   },
   pastfightsfights: state => {
     return state.pastfightsfights
   },
   usersvotes: state => {
     return state.usersvotes
   },
   selectorNames: state => {
     return state.selectorNames
   },
   updatedata: state => {
     return state.updatedata
   }

};
const actions = {
   //user auth and state of arrays
   setUser: ({commit}, currentUser) => {
      // console.log('dane', currentUser)
      commit('SET_USER', currentUser)
      // commit('SET_SIGNEDIN', value)
   //  console.log('state.user', currentUser)
  },
  setSignedIn: ({commit}, value) => {
      commit('SET_SIGNEDIN', value)
  },
  Set_verifiyemailaddress: ({commit}, value) => {
      commit('SET_verifiyemailaddress', value)
  },
  setsetgetallfightersNull: ({commit}, value) => {
      commit('SET_setgetallfightersNull', value)
  },
  // get fights and fighters store
  async setgetallfighters ({commit, dispatch}) {
      const fighters = []
      const querySnapshot = await getDocs(collection(db, "fighters"))
            // console.log('querySnapshot', querySnapshot)
                querySnapshot.forEach((doc) => {
                // let fighters = doc._document.data.value.mapValue.fields
                let fighter = doc.data()
                fighter.id = doc.i
                fighters.push(fighter)
               //  console.log('doc', purchaseableCertificates)
               //  console.log(`${doc.id} => ${doc.data()}`);
        })
      //console.log('fighters',fighters)

      commit('SET_setgetallfighters', fighters)

      await dispatch('set_fighters_names', fighters)
  },
  async setgetfights({commit, dispatch}){
      const fights = []
      const querySnapshot = await getDocs(collection(db, "fights"))
            // console.log('querySnapshot', querySnapshot)
                querySnapshot.forEach((doc) => {
                // let fighters = doc._document.data.value.mapValue.fields
                let fight = doc.data()
                fight.id = doc.i
                fights.push(fight)
               //  console.log('doc', purchaseableCertificates)
               //  console.log(`${doc.id} => ${doc.data()}`);
        })
      // console.log('fightS',fights)
      // dispatch('getfights',fighters)
      // dispatch('getfights')
      commit('SET_setgetallfights', fights)
      await dispatch('setNewarrayoffighters')
  },
  async set_fighters_names({state, commit}) {
      // console.log('set_fighters_names', state.fighters);

      let fightersNames = state.fighters
      // console.log('fightersNames', fightersNames);

      let nameFromId = fightersNames.reduce(
          (acc, {uid, Name, Surname}) => (acc.set(uid, Name + ' ' + Surname), acc),
          new Map()
      );

      let fighter_array = []
      nameFromId.forEach((key,value) => {
        //console.log("key is",key)
        //console.log("value is",value)
        fighter_array.push({"id":value,"name":key})
      })

      // console.log("fighter array is",fighter_array)

      commit('SET_fightersnames', nameFromId)
      commit('SET_selectorNames', fighter_array)

  },
  async setNewarrayoffighters({state, commit}) {
   let thefightersname = state.fightersNames 
   //console.log('thefightersname', thefightersname)
   let thefights = state.fights

   state.loaded_fights = []

    thefights.forEach(element => {

      element.Fighter_1 == thefightersname.get(element.Fighter_1)
      //console.log(' element.Fighter_1',  element.Fighter_1)
      element.Fighter_2 == thefightersname.get(element.Fighter_2)
      //console.log(' element.Fighter_2',  element.Fighter_2)

      let loaded_fight = {
         uid: element.uid,
         Fighter_1: thefightersname.get(element.Fighter_1),
         Fighter_2: thefightersname.get(element.Fighter_2),
         Rounds: element.Rounds,
         Weightdivision: element.Weightdivision,
         Votes: element.Votes,
         DateStart: element.DateStart,
         TimeStart: element.TimeStart,
         DateEnd: element.DateEnd,
        TimeEnd: element.TimeEnd,
         DateAdded: element.DateAdded
      }

      state.loaded_fights.push(loaded_fight)

      //console.log("formatted fight is",state.loaded_fights)
      //}
   });
   commit('SET_getfights', state.loaded_fights)

   // console.log('thefighters', thefights)

   // console.log('thefightersname', thefightersname)
   // console.log('thefighters', thefighters)
  },
  fightupdatelistener({commit , dispatch}) {
    let updatedata = false
    db.collection('fights')
      .onSnapshot(snapshot=>{
     let newfights = snapshot.docChanges()

     //console.log("new fights is ",newfights)

     let unsorted_data = []
         newfights.forEach((element)=>{
          unsorted_data.push(element.doc.data())

         })
         //console.log("unsorted data is",unsorted_data)

          // let doc = change.doc.data()
          // console.log('changed!', doc);
          // if(!doc){
          //   updatedata = false
          // }
          // else {
          //   updatedata = true
          // }
          let sorted_fights = unsorted_data.sort((a,b) => (a.DateAdded > b.DateAdded) ? 1 : ((b.DateAdded > a.DateAdded) ? -1 : 0))
          //console.log("sorted data is ", sorted_fights)
          let last_updated = sorted_fights[0]
          //console.log("sorted last updated is",last_updated)
          if(!last_updated){
            updatedata = false
          }
          else {
            updatedata = true
          }
          // state.heyyy = true
          // commit('SET_getnewpostpopup', state.heyyy)
          // let editedStudent = doc.data()
          // console.log(editedStudent);
          // let ioldStudent = this.studentsList.findIndex(student=> student.studentID==editedStudent.studentID)
          // this.$set(studentsList, ioldStudent , editedStudent)
      
        //console.log('updatedata', updatedata)
        commit('SET_datatoupdate', updatedata)
        // console.log('changed! outside', doc);
      }) 
      
  },
  sortFightByDateAdded(fights){
    sorted_fights = fights.sort(this.compare)
    //console.log("sorted fights is ",sorted_fights)
    return sorted_fights

  },
  compare(a,b){
    if (a.DateAdded < b.DateAdded){
      return -1
    }
    if(a.DateAdded > b.DateAdded){
      return 1
    }
    return 0
  },
  setdataupdatetofalse({state, commit, dispatch}) {
    dispatch('setgetfightsjoin')
    state.updatedata = false
    commit('SET_datatoupdate', state.updatedata)
  },

  async setgetfightsjoin({ commit, dispatch } ) {

      state.fightsdata = []
      let i = 1;
      
      const querySnapshot = await getDocs(collection(db, "fights"));
      // console.log('querySnapshot', querySnapshot)
       querySnapshot.forEach(async (doc) => {
        // let fighters = doc._document.data.value.mapValue.fields
        let fightjoin = doc.data();
        //console.log(fightjoin)

        // console.log('fightjoin', fightjoin)

        const fighter1 = query(
          collection(db, "fighters"),
          where("uid", "==", fightjoin.Fighter_1)
        );
        const fighter2 = query(
          collection(db, "fighters"),
          where("uid", "==", fightjoin.Fighter_2)
        );

        const Fighter1Data = await getDocs(fighter1);
        const Fighter2Data = await getDocs(fighter2);

        // console.log(
        //   "fighter2UID",
        //   Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
        //     "fields"
        //   ]
        // );


        let loaded_fightsData = {
          Fightuid: fightjoin.uid,
          Rounds: fightjoin.Rounds,
          Weightdivision: fightjoin.Weightdivision,
          FightTitle: fightjoin.FightTitle,
          Story: fightjoin.Story,
          DateAdded: fightjoin.DateAdded,
          DateStart: fightjoin.DateStart,
          TimeStart: fightjoin.TimeStart,
          DateEnd: fightjoin.DateEnd,
          TimeEnd: fightjoin.TimeEnd,
          Winner: fightjoin.Winner,
          WinBy: fightjoin.WinBy,
          KoRoundVote: fightjoin.KoRoundVote,
          DecisionRoundVote: fightjoin.DecisionRoundVote,
          VoteCount: fightjoin.VoteCount,
          Fighter1: fightjoin.Fighter_1,
          Fighter1Name:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Name"]["stringValue"],
          Fighter1Image:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Image"]["stringValue"],
          Fighter1ImageName:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["ImageName"]["stringValue"],
          Fighter1Percentage:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Percentage"]["stringValue"],
          Fighter2: fightjoin.Fighter_2,
          Fighter1SurName:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Surname"]["stringValue"],
            Fighter1Country:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["countries"]["stringValue"],
            Fighter1Wins:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Wins"]["stringValue"],
            Fighter1Wins_by_KO:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Wins_by_KO"]["stringValue"],
            Fighter1Losses:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Losses"]["stringValue"],
            Fighter1Losses_by_KO:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Losses_by_KO"]["stringValue"],
            Fighter1Draws:
            Fighter1Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Draws"]["stringValue"],



          Fighter2: fightjoin.Fighter_2,
          Fighter2Name:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Name"]["stringValue"],
          Fighter2SurName:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Surname"]["stringValue"],
          Fighter2Percentage:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Percentage"]["stringValue"],
          Fighter2Image:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Image"]["stringValue"],
          Fighter2ImageName:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["ImageName"]["stringValue"],
            Fighter2Country:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["countries"]["stringValue"],
            Fighter2Wins:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Wins"]["stringValue"],
            Fighter2Wins_by_KO:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Wins_by_KO"]["stringValue"],
            Fighter2Losses:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Losses"]["stringValue"],
            Fighter2Losses_by_KO:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Losses_by_KO"]["stringValue"],
            Fighter2Draws:
            Fighter2Data.docs[0]["_document"]["data"]["value"]["mapValue"][
              "fields"
            ]["Draws"]["stringValue"],



        };
         

         state.fightsdata.push(loaded_fightsData)
          console.log("loaded_fightsData", state.fightsdata);

        
        //  let heyyyyy = state.fightsdata

         dispatch('getfightdata')

         if(querySnapshot.size == i){
            commit('SET_getfightsandfightersjoin', state.fightsdata)
         }
         i++;
      })
    },
    getfightdata({commit}) {
      let todayfights = []
      let upcomingfights = []
      let pastfightsfights = []
      let todaysfights = state.fightsdata
      // console.log('todaysfights', todaysfights)
      todaysfights.forEach(element => {
        let thefight = element
        // console.log('thefight', thefight.Fightuid)
       let now = moment().valueOf()

        let startTime = element.TimeStart
        let endTime = element.TimeEnd

        let fightstartdate = moment(element.DateStart + " " + startTime, "dddd, MMMM Do YYYY" + " " + 'HH:mm').valueOf()
        let fightenddate = moment(element.DateEnd + " " + endTime, "dddd, MMMM Do YYYY" + " " + 'HH:mm').valueOf()

        // console.log("element ", element)
        // console.log("start ", fightstartdate)
        // console.log("end ", fightenddate)
        // console.log("now",now)   

        if(fightenddate < now){
            pastfightsfights.push(thefight)
            commit('SET_getpastfights', pastfightsfights)
            //  console.log('pastfightsfights', pastfightsfights)
        }else if(fightstartdate > now) {
            upcomingfights.push(thefight)
            commit('SET_getupcomingfights', upcomingfights)
          // console.log('upcomingfights', upcomingfights)
        }else {
          // console.log('error')
          todayfights.push(thefight)
          commit('SET_gettodayfights', todayfights)
          // console.log('todayfights', todayfights)
        }
      });
    },
    async getusersvotes({ commit  }, user) {
      let usersvotes = []
      const q = query(collection(db, "votes"), where("useruid", "==", state.user.uid));

      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {

        let userscurrentvotes = doc.data()

        usersvotes.push(userscurrentvotes)

        // dispatch('getusersfantacyfights')


        // doc.data() is never undefined for query doc snapshots
        // console.log('userscurrentvotes', userscurrentvotes);
      });
      commit('SET_getupvotes', usersvotes)
      // dispatch('getusersfantacyfights')
    }


};
const mutations = {
   'SET_USER' (state, user){
      state.user = user
   },
   'SET_SIGNEDIN' (state, signedin) {
      state.signedin = signedin
   },
   'SET_setgetallfighters' (state, fighters) {
      state.fighters = fighters
   },
   'SET_setgetallfights' (state, fights) {
      state.fights = fights
   },
   'SET_setgetallfightersNull' (state, fighters) {
      state.fighters = fighters
   },
   'SET_getfights' (state, loaded_fights) {
      state.loaded_fights = loaded_fights
   },
   'SET_verifiyemailaddress' (state, verifiyemailaddress){
      state.verifiyemailaddress = verifiyemailaddress
   },
   'SET_fightersnames' (state , nameFromId) {
      state.fightersNames = nameFromId
   },
   'SET_getfightsandfightersjoin' (state , fightsdata){
      // let parsedobj = JSON.parse(JSON.stringify(fightsdata))
         // console.log(parsedobj)
      // console.log('mutation', fightsdata)
      state.fightsdata = fightsdata
   },
   'SET_gettodayfights' (state , todayfights){
      // let parsedobj = JSON.parse(JSON.stringify(fightsdata))
         // console.log(parsedobj)
      // console.log('mutation', todayfights)
      state.todayfights = todayfights
   },
   'SET_getupcomingfights' (state , upcomingfights){
      // let parsedobj = JSON.parse(JSON.stringify(fightsdata))
         // console.log(parsedobj)
      // console.log('mutation', upcomingfights)
      state.upcomingfights = upcomingfights
   },
   'SET_getpastfights' (state , pastfightsfights){
      // let parsedobj = JSON.parse(JSON.stringify(fightsdata))
         // console.log(parsedobj)
      // console.log('mutation', pastfightsfights)
      state.pastfightsfights = pastfightsfights
   },
   'SET_getupvotes' (state , usersvotes){
      // let parsedobj = JSON.parse(JSON.stringify(fightsdata))
         // console.log(parsedobj)
      // console.log('mutation', pastfightsfights)
      state.usersvotes = usersvotes
   },
   'SET_selectorNames' (state, selectorNames) {
     state.selectorNames = selectorNames
   },
   'SET_datatoupdate' (state, updatedata) {
     state.updatedata = updatedata
   }
   
};
export default {
   state,
   getters,
   actions,
   mutations
}